import React from "react";

const wrapper = {
  position: "fixed",
  right: 0,
  top: 0,
  width: "380px",
  height: "100vh",
  background: "rgba(10,10,30,0.95)",
  boxShadow: "-2px 0 20px rgba(0,255,255,0.3)",
  padding: "20px",
  overflowY: "auto",
  borderLeft: "2px solid #0ff",
  color: "#0ff"
};

const closeBtn = {
  background: "rgba(0,60,60,0.6)",
  padding: "10px 18px",
  borderRadius: "6px",
  border: "1px solid #0ff",
  color: "#0ff",
  cursor: "pointer",
  boxShadow: "0 0 6px #0ff"
};

const rowStyle = {
  marginBottom: "12px",
  paddingBottom: "8px",
  borderBottom: "1px solid rgba(0,255,255,0.2)"
};

const label = {
  color: "#06f7f7",
  fontWeight: 600,
  fontSize: "14px"
};

const value = {
  color: "#fff",
  fontSize: "14px"
};

const SignalDetailDrawer = ({ open, data, onClose }) => {
  if (!open || !data) return null;

  const keys = Object.keys(data);

  return (
    <div style={wrapper}>
      <button onClick={onClose} style={closeBtn}>Close</button>

      <h2 style={{ marginTop: "20px", textShadow: "0 0 6px #0ff" ,color:"yellow"}}>
        Signal Details
      </h2>

      {keys.map((key) => (
        <div key={key} style={rowStyle}>
          <div style={label}>{key.replace(/_/g, " ").toUpperCase()}</div>
          <div style={value}>{String(data[key])}</div>
        </div>
      ))}
    </div>
  );
};

export default SignalDetailDrawer;
